/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align */

import { WindowType       } from './window';
import { DocumentMetadata } from './document.metadata';

/**
 *
 * @class ScenarioBrowserMetadata
 *
 * @brief meta data for scenario browser (table view  of a scenario)
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class ScenarioBrowserMetadata extends DocumentMetadata {

  /* the blob key of the scenario...if it's a blob in the blob manager */
  public key:  string = '/';

  /* the content of the scenario file/blob (if we have it) */
  public text: string = '';

  /** standard constructor */
  constructor(
    id:       string = '',
    title:    string = '',
    key:      string = '',
    text:     string = '',
    icon:     string = '<i class="fas fa-table"></i>',
    type: WindowType = WindowType.ScenarioBrowser,
  ) {

    super(id, title, icon, type);

    this.key  = key;
    this.text = text;
  }

  /** convert this element to a simplified form that can be easily serialized */
  public node(init?: any) {

    return super.node({key: this.key});
  }

  /** initialize this element given the data in the simplified node object */
  public fromNode(node: any) {

    super.fromNode(node);

    this.key  = node.key;
  }
}
